import { motion, useReducedMotion } from "framer-motion";
import { heroStats, profile } from "../data/content";
import portrait from "../assets/images/foto-minha-essa.jpeg";
import { ArrowRight, ArrowUpRight } from "./Icons";
import "./Hero.css";

const rise = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: [0.22, 0.61, 0.36, 1], delay },
  }),
};

export function Hero() {
  const reduceMotion = useReducedMotion();

  // Sem animação sob `prefers-reduced-motion`: o conteúdo nunca depende
  // dela para aparecer.
  const anim = (delay) =>
    reduceMotion
      ? {}
      : { variants: rise, initial: "hidden", animate: "visible", custom: delay };

  const scrollTo = (id) => () =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="inicio" className="hero">
      <div className="hero__glow hero__glow--a" aria-hidden="true" />
      <div className="hero__glow hero__glow--b" aria-hidden="true" />

      <div className="container hero__inner">
        <div className="hero__content">
          <motion.h1 className="display hero__title" {...anim(0.08)}>
            Construo produtos digitais que unem engenharia e{" "}
            <span className="serif-accent">dados</span>.
          </motion.h1>

          <motion.p className="lead hero__lead" {...anim(0.16)}>
            Sou {profile.name}, desenvolvedor full stack. Crio aplicações web e mobile,
            integro sistemas por API e transformo dados dispersos em decisão de negócio.
          </motion.p>

          <motion.div className="hero__actions" {...anim(0.24)}>
            <button type="button" className="btn btn--primary" onClick={scrollTo("projetos")}>
              Ver projetos
              <ArrowRight size={17} className="icon" />
            </button>
            <button type="button" className="btn btn--ghost" onClick={scrollTo("contato")}>
              Falar comigo
              <ArrowUpRight size={17} className="icon icon--arrow" />
            </button>
          </motion.div>

          <motion.dl className="hero__stats" {...anim(0.32)}>
            {heroStats.map((stat) => (
              <div key={stat.label} className="hero__stat">
                <dt className="hero__stat-value">{stat.value}</dt>
                <dd className="hero__stat-label">{stat.label}</dd>
              </div>
            ))}
          </motion.dl>
        </div>

        <motion.div className="hero__visual" {...anim(0.2)}>
          <div className="hero__portrait">
            <img src={portrait} alt={`Retrato de ${profile.name}`} loading="eager" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
